import { render } from "./TagField.vue?vue&type=template&id=f359349e"
import script from "./TagField.vue?vue&type=script&lang=js"
export * from "./TagField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TagField.vue"]])

export default __exports__